import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
  DataTableServerQuery,
} from '@/components/data-table-builder/data-table.types';
import { TranslateService } from '@ngx-translate/core';

export interface ConselliersHistoryDataTableProps {
  serverQuery: DataTableServerQuery;
  translate: TranslateService;
}

export const getConselliersHistoryDataTableStructure = ({ serverQuery, translate }: ConselliersHistoryDataTableProps): DynamicDataTable => {
  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.firstName',
    accessorKey: 'firstName',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.lastName',
    accessorKey: 'lastName',
    variant: DataTableColumnVariant.TEXT,
  };

  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.members.table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };

  const dateDebutColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.dateDebut',
    accessorKey: 'dateDebut',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? new Date(value).toLocaleDateString('fr-FR') : '',
      };
    },
  };

  const dateFinColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.dateFin',
    accessorKey: 'dateFin',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string | null) => {
      return {
        value: value ? new Date(value).toLocaleDateString('fr-FR') : translate.instant('settings.committee.table.active'),
      };
    },
  };

  return {
    singular: 'settings.committee.tabs.consellier',
    plural: 'settings.committee.tabs.conselliers',
    columns: [firstNameColumn, lastNameColumn, emailColumn, dateDebutColumn, dateFinColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    serverQuery,
    enableServerActions: true,
    searchableFields: ['search'],
  };
};
